import React from 'react';
import PropTypes from 'prop-types';

import MobileListItem from '../../../../components/MobileListItem';
import ProgressBar from '../../../../components/ProgressBar';
import caret from '../../../../assets/images/caret.svg';
import delaysIndicatorGrey from '../../../../assets/images/delays-icon-inactive.svg';
import delaysIndicatorRed from '../../../../assets/images/delays-icon-active.svg';

import FavoritesStarIcon from '../../../../components/Iconoclast/FavoritesStarIcon';
import './ProjectListItem.scss';
import dataModel from '../../../../models/DataModel';

export default class ProjectListItem extends React.Component {

  constructor(props) {
    ProjectListItem.propTypes = {
      projectExpanded: PropTypes.object.isRequired,
      handleFavoriteProject: PropTypes.func,
      handleSelectProject: PropTypes.func,
      handleClickScroll: PropTypes.func,
    };
    super(props);

    const { currentUser } = props;
    const { primary_company_id, current_company_id } = localStorage;
    if (
      currentUser.super_admin ||
      (currentUser.role_name == 'admin' && primary_company_id == current_company_id)
    ) {
      this.userCanViewAllDelays = true;
    }

    this.handleSelectProject = this.handleSelectProject.bind(this);
  }

  handleSelectProject(e) {
    e.stopPropagation();
    if (this.props.handleClickScroll) {
      this.props.handleClickScroll();
    }
    this.props.handleSelectProject(this.props.projectExpanded);
    localStorage.setItem('is_offline_project',this.props.projectExpanded.is_offline_project==null?false:this.props.projectExpanded.is_offline_project);
  }

  render() {
    const { projectExpanded, handleFavoriteProject } = this.props;

    let address = '';
   
    if (projectExpanded.location) {
      address = projectExpanded.location.address + ' ' + projectExpanded.location.city + ', ' + projectExpanded.location.state + ' ' + projectExpanded.location.zip;
    }

    // let offlineChangesIndicator = null
    // if (projectExpanded.is_offline_project) {
    //   offlineChangesIndicator = <div className="project-offline-indicator" />;
    // }
    // else {
    //   offlineChangesIndicator = <div className="project-offline-indicator no-display" />;
    // }

    let delaysIndicator;
    if (this.props.fromPopup && projectExpanded.has_unread_alerts) {
      delaysIndicator = <img className='project-delays-indicator' src={delaysIndicatorRed} alt='active delay' />;
    }
    else if (this.props.fromPopup && (projectExpanded.has_alerts || (projectExpanded.has_delays && this.userCanViewAllDelays))) {
      delaysIndicator = <img className='project-delays-indicator' src={delaysIndicatorGrey} alt='inactive delay' />;
    }

    const projectCompletionPercentage = Math.floor((projectExpanded && projectExpanded.tasks_count ? (projectExpanded.tasks_completed_count ? projectExpanded.tasks_completed_count : 0) / projectExpanded.tasks_count : 0) * 100);
    const progressBar = <ProgressBar percentage={projectCompletionPercentage} thin={true}/>;
  
    return (
      <MobileListItem handleClick={this.handleSelectProject} hideArrow={this.props.fromPopup}>
        {!this.props.fromPopup &&
          <div className="project-favorite-star" onClick={(e) => handleFavoriteProject(e, projectExpanded)}>
            <FavoritesStarIcon fillColor={projectExpanded.is_favorite ? '#F5A623' : null} />
          </div>
        }
        <div className={'project-name-and-address' + (this.props.fromPopup ? ' from-popup' : '') }>
          <div className="project-name">
            {projectExpanded.name && projectExpanded.name.toUpperCase()}
            {delaysIndicator}
          </div>
          <div className="project-address">{address}</div>
          <div className="progress-container">
            <div className={'progress-bar-container'+ (this.props.fromPopup ? ' from-popup' : '')}>
              {progressBar}
            </div>
            <div className={'percentage-text'+ (this.props.fromPopup ? ' from-popup' : '')}>{projectCompletionPercentage + '%'}</div>
            <div className={'project-status' + (this.props.fromPopup ? ' from-popup' : '') +
              (projectExpanded.status == 'not_started' ? ' not-started' : projectExpanded.status == 'complete' ? ' completed' : ' in-progress')}>
              {projectExpanded.status == 'not_started' ? 'Not Started' : projectExpanded.status == 'complete' ? 'Complete' : 'In Progress'}</div>
          </div>
        </div>
        {dataModel.mobileBridge.isMobile && this.props.fromPopup && (
          <img className="goto-caret" src={caret} alt="project"/>
        )}
        {/* {offlineChangesIndicator} */}
      </MobileListItem>
    );
  }
}



// WEBPACK FOOTER //
// ./src/mobileWrappers/ProjectsListWrapper/ProjectsList/ProjectListItem/index.js